import { ConnectionStatusMessage } from './types';

type MessageHandler = (data: ConnectionStatusMessage) => void;
type ErrorHandler = (error: Event) => void;

export class ConnectionStatusWS {
    private ws: WebSocket | null = null;
    private url = 'wss://lukkypro.ru/ws/v1/connections/get_connection_statuses';

    connect(onMessage: MessageHandler, onError?: ErrorHandler) {
        this.ws = new WebSocket(this.url);

        this.ws.onopen = () => {
            console.log('[WS] Connected at', new Date().toISOString());
        };

        this.ws.onmessage = (event) => {
            const now = new Date();
            try {
                const data: ConnectionStatusMessage = JSON.parse(event.data);
                console.log(`[WS][${now.toISOString()}] message`, data);
                onMessage(data);
            } catch (err) {
                console.error('[WS] Failed to parse message', err);
            }
        };

        this.ws.onerror = (error) => {
            console.error('[WS] WebSocket error', error);
            if (onError) onError(error);
        };

        this.ws.onclose = () => {
            console.log('[WS] Connection closed');
        };
    }

    disconnect() {
        if (this.ws) {
            this.ws.close();
            this.ws = null;
        }
    }
}
